import {
  doCreateProvider,
  type U3202ActivatedModelRow,
  type U3202OrgProviderConfigFormData,
  type U3202ProviderGet,
  u3202RowToModelInput,
} from '../U3202Service';
import { u3202BuildProviderCreateBody } from './u3202ParameterFormUtils';

/**
 * Création fournisseur org + modèles en un seul appel (BL-0147).
 */
export async function u3202CreateProviderWithModels(params: {
  axios: import('axios').AxiosInstance;
  data: U3202OrgProviderConfigFormData;
}): Promise<U3202ProviderGet> {
  const body = u3202BuildProviderCreateBody(params.data);
  const response = await doCreateProvider(params.axios, body);
  return response.data?.result as U3202ProviderGet;
}

/** @deprecated plus de double save catalogue/config */
export function u3202HasCatalogChanges(_rows: U3202ActivatedModelRow[], _deletedCount = 0): boolean {
  return false;
}

/** @deprecated */
export async function u3202PersistProviderCatalog(): Promise<never> {
  throw new Error('u3202PersistProviderCatalog supprimé (BL-0147)');
}

export { u3202RowToModelInput as u3202ActivatedRowToModelInput };

